module.exports = __webpack_public_path__ + "img/logotravelsafe.ba845275.jpg";